import {
    IProductsUnitItem
} from "@/entity/warehouse/Products/Unit/Unit.types"

export default class ProductsUnitTypes implements IProductsUnitItem {
    id: number | null
    name: string
    symbol: string
    constructor(data: IProductsUnitItem) {
        this.id = data.id
        this.name = data.name
        this.symbol = data.symbol
    }
}